import React from 'react';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import { Element, Icon, RouterLink, Section } from 'src/components';
import TitleWrap from 'src/modules/shared/components/TitleWrap';
import { useTracking } from 'src/hooks/useTracking';
import { ContentList } from 'src/modules/content/components/list';
import { SECTION_ID } from 'src/constants';

interface IProps extends IBaseSection<IContent> {
    ContentItemComponent?: React.FunctionComponent<any>;
}

export function ContentTopicType1Section(props: IProps) {
    const {
        items = [],
        title = '',
        link = '',
        className = cn(
            'topic-section',
            'relative',
            'border-y-[6px] border-solid border-[#F5F6F7]',
            'mt-[24px] mb-[20px] p-[4px_20px_4px]',
            'ml-[-20px]',
            'w-[calc(100%+40px)]',
        ),
        id,
        displayTimeIn,
        position,
        tracking = `|type_01|${position}|${id}`,
    } = props;

    const trackingRef = useTracking(id, `imps_type_01|${position}`, {
        threshold: 0.5,
    });

    if (!items.length) {
        return null;
    }

    return (
        <Section className={className} domRef={trackingRef}>
            <TitleWrap
                title={title?.indexOf('#') > -1 ? title.slice(1) : title}
                link={link}
                renderAs="h2"
                data-text={`${title}`}
                className={cn(
                    'relative',
                    'text-[20px]',
                    'h-[44px]',
                    'leading-[44px]',
                    'font-[900]',
                    'uppercase',
                    'text-[#286C80]',
                    'mb-[4px]',
                )}
                classNameLink={cn(
                    "before:content-['#']",
                    'before:inline-block',
                )}
            />
            <Element className={'bm-topic-type1'}>
                <ContentList
                    type="rank"
                    sectionId={`${SECTION_ID.CONTENT_BY_TOPIC}`}
                    items={items.slice(0, 1)}
                    tracking={tracking}
                    displayTimeIn={displayTimeIn}
                    hasLayoutPhoto={false}
                    ContentItemProps={{ lazyloadImage: false }}
                    ContentItemClass={{
                        CardImageClass: 'is-large',
                        CardHeaderClass: '!text-[20px] !leading-[1.4]',
                    }}
                />
            </Element>
            <Element className={cn('mt-[24px]')}>
                <ContentList
                    sectionId={`${SECTION_ID.CONTENT_BY_TOPIC}`}
                    items={items.slice(1, 3)}
                    tracking={tracking}
                    displayTimeIn={displayTimeIn}
                    hasLayoutPhoto={false}
                    className={cn(
                        'flex gap-x-[12px]',
                        'overflow-hidden',
                    )}
                    ContentItemProps={{ lazyloadImage: false }}
                    ContentItemClass={{
                        CardClass: cn(
                            '!block !w-[calc(50%-6px)] shrink-0',
                            '!border-none',
                            '!mt-0 !pt-0',
                        ),
                        CardImageClass: '!w-full !pb-[66.88%] my-0',
                        CardContentClass: '!ml-0 !pt-[12px]',
                    }}
                />
            </Element>
            <RouterLink
                to={link}
                className={cn(
                    'uppercase text-[14px] leading-[1] font-semibold',
                    'h-[36px]',
                    'flex items-center justify-center',
                    'mt-[16px]',
                )}
            >
                <Icon
                    icon="new-video-expand-regular"
                    className="text-[16px] mr-[8px]"
                />
                <span>Xem thêm</span>
            </RouterLink>
        </Section>
    );
}

export default React.memo(ContentTopicType1Section);
